import { ExportFormat, Delimiter } from 'core/types/Settings';
import { JsonObject } from '../types';

export class ExportSettings {
  public exportFormat: ExportFormat;
  public delimiter: Delimiter;

  constructor(json?: JsonObject) {
    this.exportFormat = json?.exportFormat ? json.exportFormat : 'SETTINGS_EXPORTFORMAT_OPTION_NONE';
    this.delimiter = json?.delimiter ? json.delimiter : 'SETTINGS_EXPORTDELIMITER_OPTION_COMMA';
  }
}
